import React from 'react';
import { formatAuditDateTime } from '@/utils/dateFormat';

interface AuditInfoProps {
  createdBy?: string | null;
  updatedBy?: string | null;
  updatedAt?: string | null;
}

const AuditInfo: React.FC<AuditInfoProps> = ({ createdBy, updatedBy, updatedAt }) => {
  return (
    <div className="mt-5 space-y-4">
      <div className="border-y border-gray-200 py-2 text-base text-gray-800">
        システム情報
      </div>
      <dl className="grid grid-cols-12 gap-y-2 text-sm text-gray-500">
        <dt className="col-span-1">作成者:</dt>
        <dd className="col-span-11">{createdBy ?? '-'}</dd>
        
        <dt className="col-span-1">更新者:</dt>
        <dd className="col-span-11">{updatedBy ?? '-'}</dd>
        
        <dt className="col-span-1">更新日時:</dt>
        <dd className="col-span-11">{formatAuditDateTime(updatedAt)}</dd>
      </dl>
    </div>
  );
};

export default AuditInfo;
